module.exports = __webpack_public_path__ + "img/logo-aig.9cc4346a.png";